<template>
  <div class="home">
	  
    <div ref="banner" class="banner content-item-block">
      <div class="video-wrapper">
        <video
          ref="video"
          class="video"
          preload="auto"
          muted
          loop
          playsinline
          autoplay
          poster= "../assets/images/video-poster_1576231362701.png"
          src="../assets/video/home.mp4"
          tabindex="-1"
        ></video>
		<!-- src="http://192.168.51.67:8000/static/videos/gongquhunjian_1080.min.mp4" -->
      </div>
      <h1 class="banner-title">
        专注于视觉检测产品研发、制造及应用
        <div class="subTitle">见微知著，引领未来</div>
      </h1>
      <div class="search">
        <input-search @search="searchProducts" placeholder="输入产品或需求进行搜索"></input-search>
      </div>
      <div class="bottom-tips">
        <span class="arrow-down" @click="scrollDown">
          <i>⤓</i>
        </span>
        <span class="vertical-dashed"></span>
      </div>
    </div>

    <!-- 产品 -->
    <div class="main">
		
     <div ref="product" class="product content-item-block" style="width: 80%;margin: auto;">
        <h1 class="title">关于中科淞塔</h1>
        <div class="desc">
			中科淞塔（苏州）科技有限公司专注于工业智能视觉领域，是一家集机器视觉产品的设计、研发、制造及应用于一体的高新技术企业。公司紧密围绕现代工业智能制造及智能运维过程中的工艺需求，致力于为批量可复制的应用场景提供完整的机器视觉解决方案。
		</div>
		<div style="margin-top: 50px;">
			<div style="float: left;margin-top: 60px;">
				<img src="../../public/favicon.ico.png" style="border-radius: 10px; box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);"/>
			</div>
			
			<div style="margin-left:40%; font-size: 20px;">
				<h1>公司简介</h1>
				<p style="line-height:50px">{{ companyInfo.company_intro }}</p>
				
				<div style="margin-top: 10px; display: flex;">
					<!-- 左侧空白 -->
					<div style="flex: 1;"></div>
					<!-- 按钮1 -->
					<div style="flex: 4;">
						<div class="job-detail-button job-detail-block">
							<!-- <bytedance-button size="large" link-to>关于我们</bytedance-button> -->
							<router-link to="/about">
							  <bytedance-button size="large">关于我们</bytedance-button>
							</router-link>
						</div>
					</div>
					<!-- 中间空白 -->
					<div style="flex: 2;"></div>
					<!-- 按钮2 -->
					<div style="flex: 4;">
						<div class="job-detail-button job-detail-block">
							<router-link to="/user">
							  <bytedance-button size="large">联系我们</bytedance-button>
							</router-link>
						</div>
					</div>
					<!-- 右侧空白 -->
					<div style="flex: 1;"></div>
				</div>
			</div>		
			
			<div class="items" ref="items">
				<div class="item" v-for="item in stats" :key="item.id">
				  <h3>
					<span class="sztd">{{ item.value }}</span>
					<span>+</span>
				  </h3>
				  <p class="">{{ item.label }}</p>
				</div>
			  </div>
			
		</div>
	  </div>

      <!-- 产品与解决方案 -->
	
	<div style="background-color: #FAFAFA;">
	  <div class="job-category content-item-block" style="width: 80%;margin: auto;margin-top: 20px;">
		<h2 class="job-category-title title" style="padding-top: 30px;margin-bottom: -40px;">产品与解决方案</h2>
		<ul class="job-category-list clearfix">
		  <li v-for="item in jobCategories" :key="item.id" class="job-category-item">
			
			<router-link :to="'/products/' + item.id">
			  <div class="image" :style="`backgroundImage:url(${item.image})`">
				<span class="overlay" v-if="!item.id">{{ item.zh_name }}</span>
			  </div>
			  <div v-if="item.id" class="name">{{ item.zh_name }}</div>
			</router-link>
		  </li>
		</ul>
	  </div>
	</div>

      <!-- 核心竞争力-->
      <div class="byteStandard content-item-block" style="width: 90%;margin: auto;margin-top: 30px;">
  <h1 class="title" style="text-align: center;">核心竞争力</h1>
  <div class="desc" style="text-align: center;">
    本公司以其特有的专业形象，超强的经营理念，为客户提供持续的技术咨询和尽善尽美的售后服务，消除您对检测仪器的后顾之忧,
    <br>满足您拥用广阔的市场前景和业务成长所需要的必要条件。
  </div>

  <!-- Tab 标签栏 -->
  <div class="byteStandard-tabs" style="display: flex; justify-content: center; margin-top: 30px; width: 100%;">
    <div
      v-for="(item, index) in byteStandards"
      :key="index"
      :class="['tab-item', { active: byteStandardActiveIndex === index }]"
      style="padding: 18px 60px; cursor: pointer; font-size: 22px; border-bottom: 2px solid transparent; margin: 0 32px;"
      @click="() => { byteStandardActiveIndex = index; productLayerVisible = true; loadImage(index); }"
      :style="byteStandardActiveIndex === index ? 'border-bottom: 2px solid #409EFF; color: #409EFF; font-weight: bold;' : ''"
    >
      {{ item.title }}
    </div>
  </div>

  <!-- Tab 内容区 -->
  <div class="byteStandard-tab-content" style="margin-top: 40px; width: 100%;">
    <!-- 精英团队展示区 -->
    <div v-if="byteStandards[byteStandardActiveIndex].type === 'team'"  
     class="team-showcase" 
     style="display: flex; flex-wrap: wrap; justify-content: center; gap: 40px; max-width: 1200px; margin: auto;">
  
  <div v-for="(item, index) in byteStandards[byteStandardActiveIndex].teamItems" 
       :key="index" 
       class="team-item"
       style="flex: 1 1 350px; background: #fff; border-radius: 16px; box-shadow: 0 4px 16px rgba(0,0,0,0.08); padding: 24px; text-align: center; min-width: 300px; display: flex; flex-direction: column;">

    <!-- 标题 -->
    <h4 style="font-size: 24px; font-weight: bold; margin-bottom: 16px; color: #409EFF;">{{ item.title }}</h4>
    
    <!-- 内容描述，多段 -->
    <div v-for="(paragraph, pIndex) in item.content" :key="pIndex" 
         style="font-size: 16px; color: #666; line-height: 1.6; margin-bottom: 16px;">
      {{ paragraph }}
    </div>

    <!-- 统一高度容器，保证饼图 / 校徽 / 图片同高 -->
    <div style="flex: 1; display: flex; align-items: center; justify-content: center; min-height: 250px; margin-bottom: 20px;">
      
      <!-- 高知 - 饼状图 -->
      <div v-if="item.chartData" style="width: 220px; height: 220px; position: relative;">
        <svg width="220" height="220" style="transform: rotate(-90deg);">
  <circle cx="110" cy="110" r="90" fill="none" stroke="#e0e0e0" stroke-width="20"/>
  
  <!-- 博士 30% -->
  <circle cx="110" cy="110" r="90" fill="none" stroke="#409EFF" stroke-width="20"
          :stroke-dasharray="`${0.3 * 565.49} ${0.7 * 565.49}`"
          stroke-dashoffset="0"/>
  
  <!-- 硕士 50% -->
  <circle cx="110" cy="110" r="90" fill="none" stroke="#67C23A" stroke-width="20"
          :stroke-dasharray="`${0.5 * 565.49} ${0.5 * 565.49}`"
          :stroke-dashoffset="`-${0.3 * 565.49}`"/>
  
  <!-- 高工 20% -->
  <circle cx="110" cy="110" r="90" fill="none" stroke="#E6A23C" stroke-width="20"
          :stroke-dasharray="`${0.2 * 565.49} ${0.8 * 565.49}`"
          :stroke-dashoffset="`-${(0.3+0.5) * 565.49}`"/>
</svg>
        <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); text-align: center;">
          <div style="font-size: 18px; font-weight: bold; color: #333;">团队构成</div>
        </div>
      </div>

      <!-- 朝气 - 校徽 -->
      <div v-if="item.schoolLogos" style="display: flex; justify-content: center; gap: 20px; flex-wrap: wrap;">
        <div v-for="(logo, logoIndex) in item.schoolLogos" :key="logoIndex" 
             style="width: 70px; height: 70px; border-radius: 50%; overflow: hidden; border: 2px solid #409EFF;">
          <img :src="logo" alt="校徽" style="width: 100%; height: 100%; object-fit: cover;"/>
        </div>
      </div>

      <!-- 创新 - 图片 -->
      <div v-if="item.image" style="width: 100%; max-width: 320px; height: 180px;">
        <img :src="item.image" alt="创新" style="width: 100%; height: 100%; object-fit: cover; border-radius: 8px;"/>
      </div>

    </div>

    <!-- 高知图例或校徽说明 -->
    <div v-if="item.chartData" style="display: flex; justify-content: space-around; font-size: 14px; margin-bottom: 10px;">
      <div style="display: flex; align-items: center;">
        <div style="width: 12px; height: 12px; background: #409EFF; border-radius: 50%; margin-right: 5px;"></div>
        <span>博士 {{ item.chartData.博士 }}%</span>
      </div>
      <div style="display: flex; align-items: center;">
        <div style="width: 12px; height: 12px; background: #67C23A; border-radius: 50%; margin-right: 5px;"></div>
        <span>硕士 {{ item.chartData.硕士 }}%</span>
      </div>
      <div style="display: flex; align-items: center;">
        <div style="width: 12px; height: 12px; background: #E6A23C; border-radius: 50%; margin-right: 5px;"></div>
        <span>高工 {{ item.chartData['高级工程师'] }}%</span>
      </div>
    </div>

    <p v-if="item.schoolLogos" style="font-size: 14px; color: #999; margin-top: 10px;">知名院校背景</p>

  </div>
</div>


<!-- 人才领军展示区 -->
<div v-else-if="byteStandards[byteStandardActiveIndex].type === 'rencai'" 
     class="rencai-showcase" 
     style="display: flex; align-items: flex-start; justify-content: center; gap: 40px; flex-wrap: wrap;">

  <!-- 左侧个人照片 -->
<!-- 左侧个人照片 -->
<div class="image" style="width: 300px; flex-shrink: 0; text-align: center;">
  <img :src="byteStandards[byteStandardActiveIndex].image" 
       alt="人才领军" 
       style="width: 100%; height: auto; object-fit: cover; border-radius: 16px;"/>

  <!-- 标题 -->
  <h3 style="font-weight: bold; font-size: 28px; margin-top: 16px; color: #000000; text-align: center;">
    {{ byteStandards[byteStandardActiveIndex].name }}
  </h3>
</div>

  <!-- 右侧详情 -->
  <div class="rencai-content" style="flex: 1; max-width: 800px; font-size: 16px; line-height: 1.6;">



<!-- 简介（两列美化展示） -->
<div class="intro-grid">
  <div v-for="(line, idx) in byteStandards[byteStandardActiveIndex].intro" 
       :key="idx"
       class="intro-item">
    {{ line }}
  </div>
</div>

    <!-- 上排：研究方向 + 学术成果 -->
<!-- 上排：研究方向 + 学术成果，每个占一行 -->
<div style="display: flex; flex-direction: column; gap: 12px; margin-bottom: 20px;">

<!-- 研究方向 -->
<div>
  <h4 style="font-size: 18px; font-weight: bold; margin-bottom: 6px; color: #333;">研究方向</h4>
  <div style="display: flex; flex-wrap: wrap; gap: 12px; color: #666;">
    <div v-for="(item, i) in byteStandards[byteStandardActiveIndex].research" :key="i" 
         style="display: flex; align-items: center; gap: 6px;">
      <span style="width: 10px; height: 10px; background: #409EFF; border-radius: 50%; flex-shrink: 0;"></span>
      <span>{{ item }}</span>
    </div>
  </div>
</div>

<!-- 学术成果 -->
<div>
  <h4 style="font-size: 18px; font-weight: bold; margin-bottom: 6px; color: #333;">学术成果</h4>
  <div style="display: flex; flex-wrap: wrap; gap: 12px; color: #666;">
    <div v-for="(item, i) in byteStandards[byteStandardActiveIndex].achievements" :key="i" 
         style="display: flex; align-items: center; gap: 6px;">
      <span style="width: 10px; height: 10px; background: #67C23A; border-radius: 50%; flex-shrink: 0;"></span>
      <span>{{ item }}</span>
    </div>
  </div>
</div>

</div>


    <!-- 下排：代表荣誉 + 项目与竞赛获奖 -->
    <div style="display: flex; gap: 40px; flex-wrap: wrap;">
      <!-- 代表荣誉 -->
      <div style="flex: 1; min-width: 200px;">
        <h4 style="font-size: 18px; font-weight: bold; margin-bottom: 10px; color: #333;">代表荣誉</h4>
        <ul style="margin-left: 0; padding-left: 0; color: #666;">
          <li v-for="(item, i) in byteStandards[byteStandardActiveIndex].honors" 
              :key="i" 
              style="position: relative; padding-left: 20px; margin-bottom: 6px;">
            <span style="position: absolute; left: 0; top: 6px; width: 10px; height: 10px; background: #E6A23C; border-radius: 50%;"></span>
            {{ item }}
          </li>
        </ul>
      </div>

      <!-- 项目与竞赛获奖 -->
      <div style="flex: 1; min-width: 200px;">
        <h4 style="font-size: 18px; font-weight: bold; margin-bottom: 10px; color: #333;">项目与竞赛获奖</h4>
        <ul style="margin-left: 0; padding-left: 0; color: #666;">
          <li v-for="(item, i) in byteStandards[byteStandardActiveIndex].awards" 
              :key="i" 
              style="position: relative; padding-left: 20px; margin-bottom: 6px;">
            <span style="position: absolute; left: 0; top: 6px; width: 10px; height: 10px; background: #F56C6C; border-radius: 50%;"></span>
            {{ item }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>



<!-- 新增：公司荣誉证书展示区 -->
<div v-else-if="byteStandards[byteStandardActiveIndex].type === 'honor'" 
     class="honor-gallery">
  <!-- maincertificates 区域（第一排） -->
  <div class="main-certificates">
    <div v-for="(cert, idx) in byteStandards[byteStandardActiveIndex].maincertificates" 
     :key="idx" 
     class="certificate"
     :style="{
       zIndex: Math.floor(byteStandards[byteStandardActiveIndex].maincertificates.length/2) - Math.abs(idx - Math.floor(byteStandards[byteStandardActiveIndex].maincertificates.length/2))
     }">
<img :src="cert" 
     alt="公司证书" 
     class="cert-img"
     @click="openPreview(cert)">
  <div class="reflection" :style="{ backgroundImage: 'url(' + cert + ')' }"></div>
</div>

  </div>
  <div v-if="showPreview" class="preview-overlay" @click="closePreview">
  <img :src="previewImage" alt="预览" class="preview-img" @click.stop>
</div>
  <!-- 轮播图区域（第二排） -->
  <div class="multi-carousel-container">
    <div class="carousel-track" :style="{ transform: `translateX(-${currentSlide * (100 / itemsPerPage)}%)` }">
  <!-- 修复：直接渲染 byteStandards 中的全部 certificates 数据，不做切片 -->
  <div v-for="(cert, idx) in byteStandards[byteStandardActiveIndex].certificates" 
       :key="idx" 
       class="carousel-item">
       <img :src="cert" 
     alt="公司证书" 
     class="cert-img"
     @click="openPreview(cert)">
    <div class="reflection" :style="{ backgroundImage: 'url(' + cert + ')' }"></div>
  </div>
</div>

    <!-- 左右切换按钮 -->
    <button class="carousel-btn prev-btn" @click="prevSlide" :disabled="currentSlide === 0">←</button>
    <button class="carousel-btn next-btn" @click="nextSlide" :disabled="currentSlide >= maxSlide">→</button>
  </div>

  <!-- 底部指示器 -->
  <div class="carousel-dots">
    <span v-for="(dot, idx) in Math.ceil(byteStandards[byteStandardActiveIndex].certificates.length / 3)" 
          :key="idx"
          class="dot"
          :class="{ active: idx === currentSlide }"
          @click="goToSlide(idx)">
    </span>
  </div>
</div>

<div v-else-if="byteStandards[byteStandardActiveIndex].type === 'youshi'" 
     style="display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 1px; max-width: 1500px; margin: auto; text-align: center;">
  
  <!-- 标题 -->
  <h3 style="font-weight: bold; font-size: 25px; margin-bottom: 8px; color: #000;">
    {{ "智能AI平台——DeepOnce平台" }}
  </h3>

  <!-- 内容文字 -->
  <div style="font-size: 20px; line-height: 1.6; color: #444; margin-bottom: 12px;">
    <p v-html="byteStandards[byteStandardActiveIndex].content"></p>
  </div>

  <!-- 图片 -->
  <div style="width: 100%; max-width: 1200px;">
    <img :src="byteStandards[byteStandardActiveIndex].image" 
         alt="优势展示" 
         style="width: 100%; height: auto; border-radius: 16px; object-fit: contain;"/>
  </div>
</div>

    <!-- 如果不是顾问介绍和团队介绍，就保持原样 -->
    <div v-else-if="byteStandards[byteStandardActiveIndex].type !== 'consultant'" 
         style="display: flex; align-items: center; justify-content: center;">
      <div class="image" style="width: 500px; height: 500px; margin-right: 80px;">
        <img
          width="100%"
          height="100%"
          :src="byteStandards[byteStandardActiveIndex].image"
          alt
        />
      </div>
      <div class="tab-content-text" style="max-width: 700px; font-size: 22px;">
        <h3 style="font-weight: bold; font-size: 30px; margin-bottom: 24px;">{{ byteStandards[byteStandardActiveIndex].title }}</h3>
        <p v-html="byteStandards[byteStandardActiveIndex].content"></p>
      </div>
    </div>

    <!-- 顶尖顾问展示区 -->
<!-- 顶尖顾问展示区 -->
<div v-else class="consultant-list" 
     style="display: flex; flex-wrap: wrap; justify-content: center; gap: 40px;">
     <div v-for="(c, i) in byteStandards[byteStandardActiveIndex].consultants" 
     :key="i" 
     class="consultant-card"
     style="width: 280px; background: #fff; border-radius: 16px; box-shadow: 0 4px 16px rgba(0,0,0,0.08); padding: 24px; text-align: center; transition: transform 0.3s;">
  
  <!-- 头像 -->
  <img :src="c.image" alt 
       style="width: 160px; height: 160px; border-radius: 50%; object-fit: cover; box-shadow: 0 4px 12px rgba(0,0,0,0.1); margin-bottom: 16px;">
  
  <!-- 姓名 -->
  <h4 style="font-size: 22px; font-weight: bold; margin-bottom: 8px;">{{ c.name }}</h4>
  
  <!-- 职称：逐行渲染 -->
  <div style="font-size: 16px; font-weight: 500; color: #444; margin-bottom: 12px;">
    <div v-for="(line, idx) in c.title" :key="idx">{{ line }}</div>
  </div>
  
  <!-- 详细介绍：逐行渲染 -->
  <div style="font-size: 14px; color: #666; line-height: 1.6; text-align: left;">
    <div v-for="(line, idx) in c.desc" :key="idx">{{ line }}</div>
  </div>
</div>

</div>
  </div>
</div>


      <!-- 智能平台展示 -->
	  <div style="background-color: #FAFAFA;padding-bottom: 20px">
		<div class="byteLife content-item-block" style="width: 70%;margin: auto;margin-top: 20px;">
		  <h1 class="byteLife-title" style="text-align: center;padding-top: 40px;margin-bottom: 40px;">智能平台展示</h1>

		  <!-- DeepOnce智能AI平台 -->
		  <div class="block-item block-item-one" style="display: flex; align-items: center;">
			<div class="block-item-column block-item-column-text" style="flex: 0.3; padding-right: 20px;">
			  <h2 class="block-item-column-title" style="text-align: center;">DeepOnce智能AI平台</h2>
			  <div class="content">
				<div class="content-item">
				  <h2 class="content-item-title">模型快速迭代</h2>
				  <p class="content-item-desc">利用高效的算法和计算资源，实现模型的快速迭代，满足不同场景的需求。</p>
				</div>
				<div class="content-item">
				  <h2 class="content-item-title">高效数据标注</h2>
				  <p class="content-item-desc">提供高效便捷的数据标注工具，提升数据标注的质量和速度。</p>
				</div>
				<div class="content-item">
				  <h2 class="content-item-title">自研算法支持</h2>
				  <p class="content-item-desc">依托自研算法，提供高性能、可解释的AI解决方案。</p>
				</div>
			  </div>
			</div>
			<div class="block-item-column block-item-column-video" style="flex: 0.7;margin-right: 0px">
			  <video controls width="100%" height="400px" style="border: 1px solid #ccc;">
				<source src="../assets/video/DeepOnceVideo.mp4" type="video/mp4">
				您的浏览器不支持视频标签。
			  </video>
			</div>
		  </div>

		  <!-- "文景"工业质检基座大模型 -->
		  <div class="block-item block-item-one" style="display: flex; align-items: center;">
			<div class="block-item-column block-item-column-video" style="flex: 0.7; padding-right: 20px;">
			  <video controls width="100%" height="400px" style="border: 1px solid #ccc;">
				<source src="../assets/video/WenJingVideo.mp4" type="video/mp4">
				您的浏览器不支持视频标签。
			  </video>
			</div>
			<div class="block-item-column block-item-column-text" style="flex: 0.3;margin-left: 20px;">
			  <h2 class="block-item-column-title" style="text-align: center;">"文景"工业质检基座大模型</h2>
			  <div class="content">
				<div class="content-item">
				  <h2 class="content-item-title">方案定制更灵活</h2>
				  <p class="content-item-desc">通过微调大模型的方式，定制海量工业质检应用方案。</p>
				</div>
				<div class="content-item">
				  <h2 class="content-item-title">模型可靠性更强</h2>
				  <p class="content-item-desc">安全可靠基座模型保证了其在各场景上性能优异。</p>
				</div>
				<div class="content-item">
				  <h2 class="content-item-title">数据需求更小</h2>
				  <p class="content-item-desc">更少的工业数据，即可满足下游任务的需求。</p>
				</div>
			  </div>
			</div>
		  </div>
		</div>
		</div>

		<!-- 新闻中心 -->
		<!-- 新闻中心 -->
<!-- 新闻中心 -->
<div class="staffStory content-item-block" style="width: 90%; margin: auto; margin-top: 30px;">
  <h2 class="title">新闻中心</h2>

  <div style="display: flex; justify-content: space-between; margin-top: 10px; margin-bottom: 20px;">

    <!-- 第一条新闻 -->
    <div v-if="newsItems[0]" class="news-item" style="border: 2px solid #F0F0F0; width: 34%; cursor: pointer; padding: 10px;" @click="goToNews(newsItems[0].id)">
      <img :src="newsItems[0].image" alt="News 1" style="width: 100%; height: 350px; object-fit: cover;">
      <div style="background-color: #F6F6F6; padding: 10px; height: 140px;">
        <p style="color: #888; font-size: 16px;"><i class='far fa-clock'></i> {{ newsItems[0].date }}</p>
        <p style="margin: 10px 0; font-weight: bold; font-size: 18px; color: #444;">{{ newsItems[0].title }}</p>
      </div>
    </div>
    <div v-else style="width: 34%; text-align: center; padding: 50px 10px; color: #999;">
      暂无新闻
    </div>

    <!-- 第二条新闻 -->
    <div v-if="newsItems[1]" style="border: 2px solid #F0F0F0; width: 34%; cursor: pointer; padding: 10px;" @click="goToNews(newsItems[1].id)">
      <img :src="newsItems[1].image" alt="News 2" style="width: 100%; height: 350px; object-fit: cover;">
      <div style="background-color: #F6F6F6; padding: 10px; height: 140px;">
        <p style="color: #888; font-size: 16px;">{{ newsItems[1].date }}</p>
        <p style="margin: 10px 0; font-weight: bold; font-size: 18px; color: #444;">{{ newsItems[1].title }}</p>
      </div>
    </div>
    <div v-else style="width: 34%; text-align: center; padding: 50px 10px; color: #999;">
      暂无新闻
    </div>

    <!-- 第三部分：新闻列表（使用 v-for 重构） -->
    <div style="width: 30%; border: 2px solid #F0F0F0; padding: 10px;">
      <div
        v-for="news in newsItems.slice(2, 5)"
        :key="news.id"
        style="display: flex; align-items: center; margin-bottom: 20px; cursor: pointer;"
        @click="goToNews(news.id)"
      >
        <img
          :src="news.image"
          alt="News Thumbnail"
          style="width: 30%; height: 120px; object-fit: cover; border-radius: 4px;"
        >
        <div style="margin-left: 10px; flex: 1;">
          <p style="font-weight: bold; font-size: 16px; color: #444; margin: 0;">{{ news.title }}</p>
          <p style="color: #888; font-size: 14px; margin: 5px 0 0 0;">{{ news.date }}</p>
        </div>
      </div>

      <!-- 更多新闻按钮 -->
      <div style="text-align: center; margin-top: 20px;">
        <router-link to="/news">
          <bytedance-button size="large">查看更多</bytedance-button>
        </router-link>
      </div>
    </div>

  </div>
</div>
		
      <!-- 联系我们 -->
	  <div style="background-color: #FAFAFA;">
		  <div class="staffStory content-item-block" style="width: 70%;margin: auto;margin-top: 40px;">
			<h2 class="title" style="text-align: center;padding-top: 40px;margin-bottom: 40px;">联系我们</h2>
			<ul class="staffStory-list clearfix">
			  <router-link
				tag="li"
				:to="`/user`"
				v-for="item in staffStories"
				:key="item.id"
				class="staffStory-item"
			  >
				<div class="avatar">
				  <img width="100%" :src="getFullImageUrl(item.avatar)" alt srcset />
				</div>
				<div class="text">
				  <h2 class="title">{{ item.title }}</h2>
				  <div class="desc">{{ item.name }}&nbsp;|&nbsp;{{ item.department }}</div>
				  <p class="remark">{{ item.remark }}</p>
				</div>
				<div class="circular-button">→</div>
			  </router-link>
			</ul>
		  </div>
	  </div>

	  <!-- 合作伙伴 -->
	  <div class="partners content-item-block" style="width: 80%;margin: auto;margin-top: 30px;">
		  <h2 class="title">合作伙伴</h2>
		  <ul class="partners-list clearfix">
			<li v-for="(partner, index) in partners" :key="index" class="partner-item">
			  <img :src="getFullImageUrl(partner.logo)" :alt="partner.name" class="partner-logo" />
			  <div class="partner-name">{{ partner.name }}</div>
			</li>
		  </ul>
		</div>
    </div>
	
	<div style="display: none;">
		<img  src="../assets/images/core1.png"/>
		<img  src="../assets/images/core2.png"/>
		<img  src="../assets/images/core3.png"/>
		<img  src="../assets/images/core4.png"/>
		<img  src="../assets/images/core5.png"/>
	</div>
  </div>
</template>

<script>
// @ is an alias to /src
import { watchScrollDirection } from "@/helper/utilities.js";
import { getCompanyInfo } from '../api/company'
import { getContactList } from '../api/company'
import { getPartnerList } from '../api/company'

import { getProductList } from "@/api/product";
import { getLastNews } from "@/api/news";


import axios from "axios";
export default {
  name: "home",
  data() {
    return {
        companyInfo: {
          name: '',
          slogan: '',
          about_us: '',
          company_intro: '',
          vision: '',
          mission: '',
          core_values: '',
          spirit: '',
          purpose: '',
          strategy: '',
          awards: [],
          research: [],
          scenarios: []
        },
        total: 0,
    page: 1,
    pageSize: 12,
        showPreview: false, // 是否显示大图预览
        previewImage: "",    // 当前点击的图片
        currentSlide: 0,
        itemsPerPage: 1, // 每次显示3张图片，可根据需要修改
    autoPlayInterval: null, // 自动播放定时器
    autoPlayDelay: 3000, // 自动播放间隔（毫秒，这里设3秒）
        productLayerVisible: true,
        search: "",
	    stats: [
		  { id: 1, value: 0, maxValue: 10, label: '全国荣誉奖项' },
		  { id: 2, value: 0, maxValue: 20, label: '机器视觉研究' },
		  { id: 3, value: 0, maxValue: 1000, label: '覆盖行业细分场景' },
		  { id: 4, value: 0, maxValue: 200, label: '服务行业头部企业' },
		],
	    observer: null,
      products: [],
      jobCategories: 
      [],
      byteStandards: [
		{
        type: "youshi",
		    "title": "技术优势",
		    "content": "以AI大模型为底座，解决多变的工业问题 。",
		    "image": require("../assets/images/youshi.png")
		},
		{
      type: "honor",
		  "title": "资质荣誉",
		  "content": "在行业内获得了多项资质认证和荣誉称号，包括2023年第一批园区领军企业、6项相关发明专利已授权，7项软件著作权已登记等。<br><br>公司多次人工智能与工业自动化领域斩获奖项，对公司技术实力和市场表现的高度认可。",
		  "image": require("../assets/images/core4.png"),
      certificates: [
  // 专利（最多 8 个）
  require("../assets/images/honnor/zhuanli1.png"),
  require("../assets/images/honnor/zhuanli2.png"),
  require("../assets/images/honnor/zhuanli3.png"),
  require("../assets/images/honnor/zhuanli4.png"),
  require("../assets/images/honnor/zhuanli5.png"),
  require("../assets/images/honnor/zhuanli6.png"),
  require("../assets/images/honnor/zhuanli7.png"),
  require("../assets/images/honnor/zhuanli8.png"),

  // 企业荣誉
  require("../assets/images/honnor/enterprise.png"),

  // 发明（最多 17 个）
  require("../assets/images/honnor/faming1.png"),
  require("../assets/images/honnor/faming2.png"),
  require("../assets/images/honnor/faming3.png"),
  require("../assets/images/honnor/faming4.png"),
  require("../assets/images/honnor/faming5.png"),
  require("../assets/images/honnor/faming6.png"),
  require("../assets/images/honnor/faming7.png"),
  require("../assets/images/honnor/faming8.png"),
  require("../assets/images/honnor/faming9.png"),
  require("../assets/images/honnor/faming10.png"),
  require("../assets/images/honnor/faming11.png"),
  require("../assets/images/honnor/faming12.png"),
  require("../assets/images/honnor/faming13.png"),
  require("../assets/images/honnor/faming14.png"),
  require("../assets/images/honnor/faming15.png"),
  require("../assets/images/honnor/faming16.png"),
  require("../assets/images/honnor/faming17.png"),
],
  maincertificates: [
require("../assets/images/honnor/zhuanli1.png"),
require("../assets/images/honnor/zhuanli2.png"),
require("../assets/images/honnor/zhuanli3.png"),
require("../assets/images/honnor/zhuanli4.png"),
require("../assets/images/honnor/zhuanli5.png"),

require("../assets/images/honnor/faming1.png"),
require("../assets/images/honnor/faming2.png"),
require("../assets/images/honnor/faming3.png"),
require("../assets/images/honnor/faming4.png"),
require("../assets/images/honnor/faming5.png"),
],
		},

    {
  type: "rencai",
  title: "人才领军",
  name: "张杰",
  image: require("../assets/images/zhangjie.png"),

  // 简介（身份/任职）
intro: [
 
  "中科院计算所副研究员、博士研究生导师",
  "CCF-CV 专委执委、CSIG 青工委委员",
  "NeurIPS 2025 领域主席、ACL 2024 领域主席",
  "苏州中科淞塔科技有限公司执行董事"
]
,

  // 研究方向
  research: [
    "物体检测与分割",
    "人脸识别",
    "对抗攻防"
  ],

  // 学术成果
  achievements: [
    "发表 40 余篇国际权威期刊和会议论文",
    "谷歌学术引用达 3300 余次",
    "拥有 10 余项人工智能领域发明专利"
  ],

  // 代表荣誉
  honors: [
    "2024 苏州姑苏创新创业领军人才",
    "2023 苏州工业园区科技领军人才",
    "2023 北京市科技新星人才计划",
    "2022 中国科学院青促会（青年人才）",
    "2021 微软亚洲研究院“铸星计划”",
    "2017 北京市优秀毕业生"
  ],

  // 项目与竞赛获奖
  awards: [
    "2024 中国图象图形学学会自然科学奖一等奖",
    "2024 中国铁道学会科学技术奖二等奖",
    "2021 IEEE IJCB 口罩人脸识别竞赛，亚军",
    "2020 IEEE FG 多模态人体检测竞赛，亚军",
    "2017 ACM MM 亲属关系识别竞赛，冠军",
    "2017 IEEE CVPR 面部关键点检测竞赛，亚军"
  ]
},

		{
		  "title": "精英团队",
		  "type": "team",
		  "teamItems": [
			{
			  "title": "高知",
        content: [
      "团队成员均毕业于国内外知名院校，拥有博士、硕士及高级工程师学位。",
      "具备扎实的专业知识和丰富的实践经验，能够快速响应市场需求，不断开发出高效、智能的视觉质检解决方案。"
    ],
        "chartData": {
				"博士": 30,
				"硕士": 50,
				"高级工程师": 20
			  }
			},
			{
			  "title": "朝气",
        content: [
      "年轻化的团队结构，平均年龄35岁，充满活力和创新精神。",
      "团队成员思维活跃，敢于挑战传统，勇于探索新技术，为公司发展注入源源不断的动力。"
    ],
        "schoolLogos": [
		
        require("../assets/images/zk_logo.jpg"),
				require("../assets/images/qinghua.jpg"),
				require("../assets/images/suzhou.jpg"),
				require("../assets/images/JapanJingdu.jpg"),
        require("../assets/images/herbin.jpg"),
        
			  ]
			},
			{
			  "title": "创新",
        content: [
      "持续的技术创新是我们的核心竞争力。",
      "团队在机器视觉、人工智能等领域拥有多项自主知识产权，拥有发明专利申请受理17件，获得授权8件；软件著作权登记20件；发表国际权威期刊与会议论文60篇。"
    ],
        "image": require("../assets/images/jietu.png")
			}
		  ]
		},
    {
  title: "顶尖顾问",
  type: "consultant",
  consultants: [ 
  { 
    name: "陈熙霖", 
    title: [
      "中科院计算所研究员、博导",
      "ACM／IEEE／CCF Fellow，国家杰青"
    ],
    image: require("../assets/images/chenxilin.jpg"), 
    desc: [
      "✓ 中国科学院计算技术研究所所长、党委书记",
      "✓ 入选中科院“百人计划”，国家杰出青年基金获得者"
    ]
  },
  { 
    name: "山世光", 
    title: [
      "中科院计算所研究员、博导",
      "IEEE Fellow，优青，万人领军"
    ],
    image: require("../assets/images/shanshiguang.png"), 
    desc: [
      "✓ 中科院智能信息处理重点实验室主任",
      "✓ 中组部万人计划创新领军人才，CCF青年科学家奖获得者"
    ]
  },
  { 
    name: "刘新宇", 
    title: [
      "中科算源资产管理公司总经理",
      "中科图灵基金总经理"
    ],
    image: require("../assets/images/liuxinyu.png"), 
    desc: [
      "✓ 中科苏州智能计算技术研究院院长",
      "✓ 主导管理中科院计算所全资的中科算源资产管理公司",
      "✓ 下辖包括曙光上市公司等三十余家公司，管理资产过百亿"
    ]
  },
  { 
    name: "张佩珩", 
    title: [
      "中科院计算所系统结构部总工",
      "国务院政府特殊津贴专家"
    ],
    image: require("../assets/images/zhangpeiheng.png"), 
    desc: [
      "✓ 参与并承担多项国家863、973项目、国家重点研发计划",
      "✓ 中科院知识创新工程重大项目负责人",
      "✓ 曙光系列高性能计算机系统主要研究者之一"
    ]
  }
]

},
		
		
	  ],
    byteStandardActiveIndex: 1,
    currentSlide: 0,
	  	byteStandardImage: require("../assets/images/core5.png"),
        byteStandardActiveIndex: 0,
        staffStories: [],

	partners: [],
	newsItems: []
    };
  },
  created() {
    this.fetchProducts();
    this.fetchCompanyInfo();
    this.fetchContacts();
    this.fetchPartners();
    this.fetchPartners(this.page);
    this.fetchLastNews('company');
        this.animateStats();
  },
  methods: {
    onScrollRightAnimationEnd() {
      this.productLayerVisible = false;
    },
    getFullImageUrl(imagePath) {
      return this.$serverUrl + imagePath;
    },
    getFullImageUrl(imagePath) {
      return this.$serverUrl + imagePath;
    },
    async fetchPartners(page = 1) {
    try {
      const res = await getPartnersList({ page, pageSize: this.pageSize });
      if (res.status === 200) {
        this.partners = res.data.list.map(item => ({
          id: item.id,
          name: item.name,
          logo: this.$serverUrl + item.logo
        }));
        this.total = res.data.total;
      } else {
        console.error("获取合作伙伴失败:", res.msg);
      }
    } catch (err) {
      console.error("请求出错:", err);
    }
  },
    async fetchContacts() {
      try {
        const res = await getContactList()
        if (res.status === 200) {
          this.staffStories = res.data.data
          console.log('联系人信息:', this.staffStories)
        } else {
          console.error('获取联系人失败:', res.msg)
        }
      } catch (err) {
        console.error('请求出错:', err)
      }
    },
    async fetchPartners(page = 1, pageSize = 12) {
  try {
    const res = await getPartnerList({ page, pageSize })  // ✅ 传参数
    if (res.data.status === 200) {
      this.partners = res.data.data.list  // ✅ 正确绑定数组
      console.log('合作伙伴信息:', this.partners)
    } else {
      console.error('获取合作伙伴失败:', res.data.msg)
    }
  } catch (err) {
    console.error('请求出错:', err)
  }
},

        // ✅ 获取产品列表
    // async fetchProducts(page = 1, pageSize = 8, keyword = "") {
      
    //   try {
    //     const res = await axios.post(this.$serverUrl + "api/getProductList/", {
    //       page,
    //       pageSize,
    //       keyword,
    //     });
    //     if (res.data.status === 200) {
    //       this.jobCategories = res.data.data.list.map((item) => {
    //         return {
    //           id: item.id,
    //           zh_name: item.name,
    //           image: this.$serverUrl + item.image,
    //         };
    //       });
    //       this.total = res.data.data.total;
    //     } else {
    //       console.error("获取产品失败:", res.data.msg);
    //     }
    //   } catch (err) {
    //     console.error("请求出错:", err);
    //   }
    // },

    async fetchProducts(page = 1, pageSize = 8, keyword = "") {
      try {
        const res = await getProductList({ page, pageSize, keyword });
        if (res.data.status === 200) {
          this.jobCategories = res.data.data.list.map(item => ({
            id: item.id,
            zh_name: item.name,
            image: this.$serverUrl + item.image
          }));
          this.total = res.data.data.total;
        } else {
          console.error("获取产品失败:", res.data.msg);
        }
      } catch (err) {
        console.error("请求出错:", err);
      }
    },

// async fetchLastNews(category = 'company') {
//   try {
//     const res = await axios.post(this.$serverUrl + "api/getLastNews/", {
//       category  // 可选：'company', 'industry', 'faq'
//     });

//  if (res.data.status === 200) {
//       this.newsItems = res.data.data.list.map(item => {
//         return {
//           id: item.id,
//           category: item.category,
//           date: item.date,
//           image: this.$serverUrl + item.image,  // 拼接完整URL
//           title: item.title,
//           summary: item.summary,
//           content: item.content  // 保留正文内容，用于弹窗或详情页
//         };
//       });
//     } else {
//       console.error("获取最新新闻失败:", res.data.msg);
//     }
//   } catch (err) {
//     console.error("请求 getLastNews 出错:", err);
//   }
// },

async fetchLastNews(category = "company") {
      try {
        const res = await getLastNews(category);
        if (res.data.status === 200) {
          this.newsItems = res.data.data.list.map(item => ({
            id: item.id,
            category: item.category,
            date: item.date,
            image: this.$serverUrl + item.image,
            title: item.title,
            summary: item.summary,
            content: item.content
          }));
        } else {
          console.error("获取最新新闻失败:", res.data.msg);
        }
      } catch (err) {
        console.error("请求 getLastNews 出错:", err);
      }
    },
    
openPreview(img) {
    this.previewImage = img;
    this.showPreview = true;
  },
  closePreview() {
    this.showPreview = false;
  },
    scrollDown() {
      this.$refs.product.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    },
    searchProducts(keyword) {
      this.$router.push({ name: "products", params: { keyword } });
    },
    
async fetchCompanyInfo() {
  try {
    const res = await getCompanyInfo(); // axios 调用返回 res.data
    if (res.status === 200) {
      // ✅ 只拿 data
      this.companyInfo = res.data.data;  // 如果你的 getCompanyInfo 已经封装了 axios instance
      
      console.log('公司信息:', this.companyInfo); // 打印真正的公司信息
    } else {
      console.error('获取公司信息失败:', res.msg);
    }
  } catch (err) {
    console.error('请求出错:', err);
  }
},
	goToNews(id){
		// this.$router.push({ name: "news", params: id });
		this.$router.push('/news/' + id);
	},
    jumpToDetail(item) {
      this.$router.push({ name: "products", params: item });
    },
	// 方法来生成完整的服务器 URL
	serverUrl(path) {
	  return this.$serverUrl + path;
	},

	loadImage(index) {
		this.byteStandardImage = "";
		this.byteStandardImage = this.byteStandards[index].image;
	},
	
	// createObserver() {
	//       const options = {
	//         root: null,
	//         threshold: 0.1,
	//       };
	//       this.observer = new IntersectionObserver(this.handleIntersect, options);
	//       this.observer.observe(this.$refs.items);
	//     },
	    handleIntersect(entries) {
	      entries.forEach((entry) => {
	        if (entry.isIntersecting) {
	          this.startCount();
	          if (this.observer) {
	            this.observer.disconnect();
	          }
	        }
	      });
	    },
  getCertificateStyle(idx, total) {
    const center = Math.floor(total / 2)   // 中心位置
    const offset = idx - center            // 相对中心的偏移量

    return {
      transform: `translateX(${offset * 80}px)`, // 左右错位展开
      zIndex: total - Math.abs(offset),          // 中心层级最高
    }
  },
// 修复后的 prevSlide 方法
prevSlide() {
    if (this.currentSlide > 0) {
      this.currentSlide--;
    }
  },
  nextSlide() {
    if (this.currentSlide < this.maxSlide) {
      this.currentSlide++;
    }
  },
  goToSlide(index) {
    this.currentSlide = index;
  },

  // 4. 启动自动播放
  startAutoPlay() {
    // 清除已有定时器，避免重复
    if (this.autoPlayInterval) clearInterval(this.autoPlayInterval);
    // 每隔autoPlayDelay切换一次
    this.autoPlayInterval = setInterval(() => {
      this.nextSlide();
    }, this.autoPlayDelay);
  },

  // 5. 停止自动播放
  stopAutoPlay() {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
      this.autoPlayInterval = null;
    }
  },
       animateStats() {
      this.stats.forEach((item) => {
        let current = 0
        let step = Math.ceil(item.maxValue / 50) // 动画步长
        let timer = setInterval(() => {
          current += step
          if (current >= item.maxValue) {
            current = item.maxValue
            clearInterval(timer)
          }
          this.$set(item, 'value', current)
        }, 30) // 每 30ms 更新一次
      })
    },
	    startCount() {
	      this.stats.forEach((stat) => {
	        const increment = stat.maxValue / 100;
	        const interval = setInterval(() => {
	          stat.value += increment;
			  // stat最多保留一位小数
			  stat.value = parseFloat(stat.value.toFixed(1));
	          if (stat.value >= stat.maxValue) {
	            stat.value = stat.maxValue;
	            clearInterval(interval);
	          }
	        }, 20);
	      });
	    }
  },
  computed: {
  // 计算最大可滑动的页数
  maxSlide() {
    const totalItems = this.byteStandards[this.byteStandardActiveIndex].certificates.length;
    console.log("aaaa",this.byteStandards[this.byteStandardActiveIndex].certificates.length)
    return Math.ceil(totalItems / 3) - 1;
  }
},
  mounted() {
    const rootVm = this.$root;
	// this.createObserver();
    rootVm.$emit(
      "home-scrolling",
      { directionX: 1, directionY: -1 },
      { x: document.body.scrollLeft, y: document.body.scrollTop }
    );
    this.unwatch = watchScrollDirection(window, function(...args) {
      rootVm.$emit("home-scrolling", ...args);
    });
    this.$nextTick(() => {
    if (this.byteStandardActiveIndex === 1) { // 假设资质荣誉是第2个Tab（索引1，根据实际调整）
      this.startAutoPlay();
    }
  });

  // 监听Tab切换：切换到资质荣誉时启动自动播放，离开时停止
  this.$watch('byteStandardActiveIndex', (newIndex) => {
    const isHonorTab = this.byteStandards[newIndex].type === 'honor';
    if (isHonorTab) {
      this.startAutoPlay();
    } else {
      this.stopAutoPlay();
    }
  });
  },
  beforeDestroy() {
	  if (this.observer) {
		this.observer.disconnect();
	  }
    this.stopAutoPlay();
	},
  destroyed() {
    this.unwatch();
  }
};
</script>

<style lang="less" scoped>
.product.content-item-block {
  width: 80%;
  margin: auto;
}

.title {
  text-align: center;
  font-size: 2.5em;
  margin-bottom: 20px;
}

.desc {
  text-align: center;
  font-size: 1.2em;
  margin-bottom: 50px;
  line-height: 1.5;
}

.items {
  display: flex;
  justify-content: space-around;
  margin-top: 60px;
}

.item {
  text-align: center;
}

.item h3 {
  font-size: 2.5em;
  color: #007bff;
}

.item p {
  font-size: 1.2em;
  color: #555;
}
.intro-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 两列均分 */
  gap: 12px 24px; /* 行间距 12px，列间距 24px */
  margin-bottom: 24px;
  color: #444;
  font-size: 16px;
  line-height: 1.6;
}

.intro-item {
  background: #f9f9f9;   /* 浅灰背景，提高可读性 */
  padding: 8px 12px;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.intro-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

@keyframes verticalMotion {
  0% {
    transform: translateY(6px);
  }
  50% {
    transform: translateY(-6px);
  }
  100% {
    transform: translateY(6px);
  }
}
@keyframes scrollToRight {
  0% {
    left: -100%;
  }

  100% {
    left: 100%;
  }
}
.preview-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.preview-img {
  max-width: 90%;
  max-height: 90%;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.5);
  transition: transform 0.3s ease;
}

.preview-img:hover {
  transform: scale(1.02);
  cursor: zoom-out;
}

.cert-img {
  cursor: zoom-in;
}

.home {
  .main {
    // width: @main-width;
	width: auto;
    margin: auto;
  }
  .content-item-block {
    .title {
      font-size: @font-size-larger;
    }
  }
}

.banner {
  height: 100vh;
  min-height: 400px;
  min-width: @main-width;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(51, 112, 255, 0.2);
  position: relative;
  .video-wrapper {
    font-size: 0;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    overflow: hidden;
    .video {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
  &-title {
    color: #fff;
    font-size: 60px;
    text-align: center;
    .subTitle {
      &::after,
      &::before {
        content: "";
        position: absolute;
        background-image: linear-gradient(
          270deg,
          hsla(0, 0%, 100%, 0),
          #fff 47%,
          hsla(0, 0%, 100%, 0)
        );
        height: 2px;
        width: 89px;
        top: 50%;
        transform: translateY(-50%);
      }
      &:before {
        right: 10px;
      }
      &:after {
        left: 10px;
      }
      position: relative;
      margin-top: 10px;
      font-size: @font-size-base;
      letter-spacing: 20px;
    }
  }
  .search {
    width: 500px;
    margin-top: 100px;
    margin-bottom: 40px;
  }
  .bottom-tips {
    position: absolute;
    bottom: 30px;
    width: 50px;
    height: 50px;
    flex-shrink: 0;

    text-align: center;
    .arrow-down {
      display: block;
      margin-bottom: 4px;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      border: 1px solid #fff;
      text-align: center;
      line-height: 40px;
      color: #fff;
      cursor: pointer;
      font-size: 21px;
      i {
        animation: verticalMotion 1.3s infinite linear;
        display: inline-block;
        font-style: normal;
      }
    }
    // 分割竖线
    .vertical-dashed {
      border-left: 1px dashed #fff;
      height: 30px;

      display: inline-block;
    }
  }
}

// 产品
.product {
  margin-top: 40px;
  text-align: center;
  padding: 40px 40px;
  background: url(//sf1-ttcdn-tos.pstatp.com/obj/ttfe/ATSX/mainland/global.png);
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: 0 370px;
  .desc {
    margin: 40px 0;
  }
  &-list {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  &-item {
    width: 90px;
    // height: 90px;
    cursor: pointer;
    &:nth-child(1),
    &:nth-child(9) {
      margin-top: 116px;
    }
    &:nth-child(2),
    &:nth-child(8) {
      margin-top: 80px;
    }
    &:nth-child(3),
    &:nth-child(7) {
      margin-top: 55px;
    }
    &:nth-child(4),
    &:nth-child(6) {
      margin-top: 30px;
    }
    &:hover {
      color: @main-color;
      img {
        border-radius: 19px;

        transform: scale(1.2);
        transform-origin: bottom;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
      }
    }
    img {
      width: 90px;
      height: 90px;
      border-radius: 19px;

      margin-bottom: 10px;
      transition: transform 0.3s;
    }
  }
  .more {
    margin: auto;
    margin-top: 170px;

    width: 149px;
  }
}

.honor-gallery {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90%;
  margin: 0 auto;
  padding: 20px 0;
  height: auto !important;
  position: static !important;
  overflow: visible !important;
}
.main-certificates {
  display: flex;
  justify-content: center;  /* 居中 */
  align-items: center;
  width: 100%;
  margin-bottom: 40px;
  padding: 10px 0;
  position: relative;
}

.main-certificates .certificate {
  width: 200px;
  transition: transform 0.3s ease;
  margin-left: -60px; /* 控制重叠程度，可以调大/调小 */
  position: relative;
}

.main-certificates .certificate:first-child {
  margin-left: 0; /* 第一个不要重叠 */
}

.main-certificates .certificate img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.3);
  object-fit: contain;
}

/* 鼠标悬停时稍微放大，让重叠更明显 */
.main-certificates .certificate:hover {
  transform: scale(1.05);
  z-index: 10;
}
.multi-carousel-container {
  position: relative;
  width: 100%;
  overflow: hidden;
  margin-bottom: 20px;
}
.carousel-track {
  display: flex;
  transition: transform 0.5s ease;
}
.carousel-item {
  flex: 0 0 calc(100% / 3);
  padding: 0 10px;
  box-sizing: border-box;
  position: relative;
}
.carousel-item img {
  width: 100%;
  border-radius: 8px;
  max-height: 200px;
  object-fit: contain;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}
/* 镜面反射 */
.carousel-item .reflection {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 40%;
  transform: scaleY(-1);
  opacity: 0.25;
  border-radius: 0 0 8px 8px;
  background-size: cover;
  background-position: top;
  filter: blur(2px);
  margin-top: 5px;
  -webkit-mask-image: linear-gradient(to bottom, rgba(0,0,0,0.6), transparent);
  mask-image: linear-gradient(to bottom, rgba(0,0,0,0.6), transparent);
}
/* 按钮 */
.carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: rgba(64, 158, 255, 0.8);
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background 0.3s;
}
.carousel-btn.prev-btn { left: 15px; }
.carousel-btn.next-btn { right: 15px; }
.carousel-btn:disabled {
  background: rgba(150, 150, 150, 0.5);
  cursor: not-allowed;
}
.carousel-btn:hover:not(:disabled) { background: #409EFF; }
/* 指示器 */
.carousel-dots {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 10px;
}
.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #ccc;
  cursor: pointer;
  transition: all 0.3s;
}
.dot.active {
  width: 30px;
  border-radius: 6px;
  background: #409EFF;
}
/* 响应式 */
@media (max-width: 1200px) {
  .main-certificates .certificate { width: 180px; }
  .carousel-item { flex: 0 0 50%; }
}
@media (max-width: 768px) {
  .main-certificates .certificate { width: 150px; }
  .carousel-item { flex: 0 0 100%; }
}


/* 响应式调整 - 在小屏幕上减少同时显示的图片数量 */
@media (max-width: 768px) {
  .carousel-item {
    flex: 0 0 50%; /* 平板上一次显示2张 */
  }
}

@media (max-width: 480px) {
  .carousel-item {
    flex: 0 0 100%; /* 手机上一次显示1张 */
  }
}

/* 按钮样式 */
.carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
  z-index: 10;
}

.prev-btn {
  left: 10px;
}

.next-btn {
  right: 10px;
}

.carousel-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 指示器样式 */
.carousel-dots {
  display: flex;
  justify-content: center;
  margin-top: 15px;
  gap: 8px;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ccc;
  cursor: pointer;
}

.dot.active {
  background: #333;
}
// 职位

.job-category {
  text-align: center;
  margin-top: 90px;

  &-list {
    margin-top: 70px;
  }
  &-item {
    float: left;
    margin-bottom: 16px;
    .image {
      width: 250px;
      height: 250px;
      line-height: 250px;
      background-repeat: no-repeat;
      background-size: 100%;
      border-radius: 50%;
      margin: auto;

      transition: all 0.3s;
      background-position: center;
      overflow: hidden;
      &:hover {
        box-shadow: 0 0 8px 1px #ccc;
        background-size: 110%;
        & + .name {
          color: @main-color;
        }
      }
      .overlay {
        display: inline-block;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        color: #fff;

        font-size: 40px;
      }
    }
    .name {
      margin-top: 23px;
      font-size: @font-size-large;
    }
    margin: 0 2.5%;
    margin-bottom: 30px;
    width: 20%;
  }
}

// 字节范

.byteStandard {
  padding: 40px 40px;
  overflow: hidden;
  .title {
    margin-bottom: 30px;
  }
  .desc {
    margin-bottom: 40px;
  }
  .content {
    .image {
      .layer {
        // left: -100%;
        width: 100%;
        top: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.8);
        position: absolute;
        animation: scrollToRight 0.8s ease-in-out;
      }

      position: relative;
	  border: 1px solid #DCDCDC;
	  border-radius: 5px;
      float: left;
      width: 900px;
      height: 500px;
      margin-right: 100px;
      overflow: hidden;
      img {
        border-radius: 6px;
        object-fit: cover;
      }
    }
  }
  .indicator {
    color: #aaa;

    &-item {
      margin: 32px 0;
      h3 {
        &.active {
          color: black;
          font-size: 32px;
          font-weight: 400;
        }
        cursor: pointer;
      }
    }
  }
}
// 字节生活
.byteLife {
  // width:1200px;
  // overflow: hidden;
  &-title {
    margin-bottom: 70px;
  }
  .block-item {
    overflow: hidden;
    margin-bottom: 100px;
    &:nth-child(odd) {
      .block-item-column {
        &-text {
          margin-right: 9%;
        }
        float: left;
      }
    }
    &:nth-child(even) {
      .block-item-column {
        &-image {
          margin-right: 9%;
        }
        float: right;
      }
    }

    &-column {
      &-title {
        margin-bottom: 40px;
        padding-bottom: 40px;
        border-bottom: 1px solid #ccc;
      }
      &-text {
        width: 30%;
      }
      &-image {
        height: 400px;
        width: 59%;
        border-radius: 8px;
        overflow: hidden;
        img {
          height: 100%;
          object-fit: cover;
        }
      }
    }
  }
}
// 员工故事
.staffStory {
  padding: 0 140px;
  .title {
    text-align: center;
    margin-bottom: 10px;
  }

  &-list {
    text-align: center;
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
  }
  &-item {
    // height: 450px;
    overflow: hidden;
    padding: 30px;
    width: 30%;
    cursor: pointer;

    &:hover {
      box-shadow: 0 10px 30px 0 @box-shadow-hover-color;
      .circular-button {
        color: @main-color;
      }
    }
    .avatar {
      width: 70%;
      margin: auto;
    }
    .text {
      .title {
        color: @primary-text-color;
        font-weight: @font-weight-regular;
        font-size: @font-size-large;
        margin: 10px 0;
        white-space: nowrap;
      }
      .desc {
        color: @primary-text-color;
        margin: 12px 0;
        font-size: @font-size-base;
      }
      .remark {
        font-size: @font-size-base;

        color: @regular-text-color;
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .circular-button {
      border-radius: 50%;
      width: 30px;
      height: 30px;
      border: 1px solid;
      line-height: 30px;

      margin: auto;
      margin-top: 20px;
      color: #ccc;
    }
  }
}

/* Add styles for the partner module */
.partners {
  text-align: center;
  padding: 10px;
}

.partners-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  list-style: none;
  padding: 0;
  margin-bottom: -20px;
  margin-top:20px;
}

.partner-item {
  flex: 1 0 21%; /* 4 items per row */
  box-sizing: border-box;
  margin: 10px;
  text-align: center;
  border: 1px solid #ddd; /* 添加淡色边框 */
  padding: 10px; /* 增加内边距 */
  border-radius: 5px; /* 可选：圆角边框 */
}

.partner-logo {
  width: 168px; /* 固定宽度 */
  height: 100px; /* 固定高度 */
  object-fit: contain; /* 确保图像在固定尺寸内按比例缩放 */
}

.partner-name {
  margin-top: 10px;
  font-size: 16px;
  font-weight: bold;
}

hr {
  border: none;
  // border-top: 2px solid #e0e0e0;
  border-top: 2px solid #000000;
  margin: 0;
}

</style>
